export const SeoKeyWord = ({seoLinks}) => {
    return (
        <section className="seo-links">
            <div>
                <h2>À découvrir aussi</h2>
                <ul>
                    {
                        seoLinks.map((link, key) => {
                            return (
                                <li key={key}><a href={link.url}>{link.label}</a></li>
                            )
                        })
                    }
                </ul>
            </div>
        </section>
    )
}